import enSwap from '@/pages-components/bridgeswap/components/DappPay/locales/en.json'
import zhSwap from '@/pages-components/bridgeswap/components/DappPay/locales/zh.json'
// import { defineI18nConfig } from '#i18n'

import en from './locales/en.json'
import zh from './locales/zh.json'

const messages = {
  zh: { ...zh, ...zhSwap },
  en: { ...en, ...enSwap },
}
const hm = { hour: '2-digit', minute: '2-digit', hour12: false } as const
const dTime = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false } as const
const dDate = { year: 'numeric', month: '2-digit', day: '2-digit' } as const
const dFull = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: false,
} as const
/** 月/日 时:分 */
const dMdhm = { month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', hour12: false }
const datetimeFormats = {
  zh: { sm: dTime, lg: dFull, time: dTime, date: dDate, full: dFull, mdhm: dMdhm, hm },
  en: { sm: dTime, lg: dFull, time: dTime, date: dDate, full: dFull, mdhm: dMdhm, hm },
} as const

export default defineI18nConfig(() => {
  return {
    legacy: false,
    locale: 'en',
    messages,
    datetimeFormats,
  }
})
